// Acting-tenant state for Super Admins. When a Super Admin "enters" a tenant
// from the Platform > Tenants page, the tenant is stored here and every API
// call / asset URL uses its identifier as the company, so the normal pages
// show that tenant's data. Reads localStorage directly (no UserService import)
// to avoid an import cycle with api.js.

const ACTING_TENANT_KEY = "actingTenant";

export const getActingTenant = () => {
  try {
    return JSON.parse(localStorage.getItem(ACTING_TENANT_KEY));
  } catch (e) {
    return null;
  }
};

export const setActingTenant = (tenant) => {
  // { identifier, name }
  localStorage.setItem(ACTING_TENANT_KEY, JSON.stringify(tenant));
};

export const clearActingTenant = () => {
  localStorage.removeItem(ACTING_TENANT_KEY);
};

// The company every request/asset should be scoped to: the entered tenant for
// a Super Admin, otherwise the logged-in user's own company. The backend only
// honors a foreign company header for Super Admins, so a stale value is safe.
export const getActiveCompany = () => {
  const acting = getActingTenant();
  if (acting?.identifier) return acting.identifier;
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.company;
  } catch (e) {
    return undefined;
  }
};
